import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Candidate } from 'app/shared/models/candidate.model';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  @ViewChild("search")
  public searchElementRef: ElementRef;
  candidateForm:FormGroup

  candidate_model = new Candidate()

  address: string;
  latitude: number;
  longitude: number;
  zoom: number;
  private geoCoder;

  currentUrl:any
  candidate_id:any
  opening_list=[]
  selected_opening = null
  constructor(private formBuilder:FormBuilder,private apiService:ApiService,
              private router:Router,public toastr: ToastrService,
              private activerouter:ActivatedRoute,private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,) { 
                // this.locationAutoComplete()
                this.currentUrl = this.activerouter.snapshot.routeConfig.path

                if(this.currentUrl =='edit/:id'){
                  this.activerouter.paramMap.subscribe(params => { 
                    this.candidate_id = params.get('id');  
                  }) 
                }
              
              }

  ngOnInit() {
    this.candidateForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', ],
      àddress: ['', ],
      jobopening: ['', ],
      experience: ['', ]
    })

    if(this.candidate_id){
      this.getCandidateById(this.candidate_id)
    }
    this.getAllOpening()
  }
  get rf(){
    return this.candidateForm.controls
  }
  getOpeningId(event){
    this.selected_opening
  }
  getAllOpening(){
    this.apiService.getOpeningListByStatus('64c2466d6ae6f958da59faee').subscribe((res:any)=>{
      this.opening_list = res?.data?.items
    })
  }
  getCandidateById(id){
    this.apiService.getCandidatesById(id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.candidate_model.address=res?.data.address
        this.candidate_model.name=res?.data?.name
        this.candidate_model.email=res?.data?.email
        this.candidate_model.phone=res?.data?.phone
        this.selected_opening = res?.data?.jobopening.map(item => item._id)
        this.candidate_model.jobopening = this.selected_opening
        this.address=this.candidate_model.address
        this.candidate_model.notes=res?.data?.notes
        this.candidate_model.admin_notes=res?.data?.admin_notes
        this.candidate_model.experience=res?.data?.experience

      }
    })
  }
  submit(){
    let body={
      name : this.candidateForm.value.name,
      email : this.candidateForm.value.email,
      phone : this.candidateForm.value.phone,
      jobopening : this.selected_opening,
      address : this.candidateForm.value.address || this.candidate_model.address,
      // lat : this.latitude,
      // lng : this.longitude,
      experience: this.candidateForm.value.experience,
      notes: this.candidate_model.notes,
      admin_notes: this.candidate_model.admin_notes,
    }
    if(this.currentUrl == 'add'){
      this.apiService.createCandidates(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Candidate add successfully')
          this.router.navigate(['/candidates-management/candidates-list'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(this.currentUrl == 'edit/:id'){
      this.candidate_model.address
      this.candidate_model.jobopening = this.selected_opening
      this.apiService.updateCandidates(this.candidate_id,this.candidate_model).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Update successfully')
          this.router.navigate(['/candidates-management/candidates-list'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
   
  }
  locationAutoComplete() {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
  
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.address = place.formatted_address;
          console.log('address', this.address)
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
  
          // set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          console.log("lat lng",this.latitude,this.longitude)
          if(this.candidate_id && this.currentUrl == 'edit/:id'){
            // this.candidate_model.address.location=this.address
            // this.candidate_model.address.coordinates=[this.latitude,this.longitude]

          }
        });
      });
    });
  }
  back(){
    this.router.navigate(['/candidates-management/candidates-list'])
  }
  inlineAddupdateBody(data ,prop) {
    if (prop == 'notes') {
        this.candidate_model.notes =data
      }
    if(prop == 'admin_notes') {
      this.candidate_model.admin_notes =data

    }

  }
}
